module.exports = __webpack_public_path__ + "static/media/trioLastResults.703878d7.png";